import { persistTrackingChange } from '../../../middleware/tracking/persistTrackingChange';
import { StudentStoreThunkAction } from '../../../../types/redux';
import { ContentItemType, SingleResponseQuestionWidget } from '@ael/core-api';

export enum QuestionWidgetTrackingActions {
  SetSelectedOption = 'SetSelectedOption',
  ResetSelectedOption = 'ResetSelectedOption',
}

export const setSelectedOption =
  (
    contentItem: ContentItemType,
    questionWidget: SingleResponseQuestionWidget,
    selectedOption: number
  ): StudentStoreThunkAction =>
  async (dispatch, getState, { trackingClient }) => {
    dispatch({
      type: QuestionWidgetTrackingActions.SetSelectedOption,
      payload: { contentItem, questionWidget, selectedOption },
    });
    await persistTrackingChange(getState, trackingClient);
  };

export const resetSelectedOption =
  (contentItem: ContentItemType, questionWidget: SingleResponseQuestionWidget): StudentStoreThunkAction =>
  async (dispatch, getState, { trackingClient }) => {
    dispatch({
      type: QuestionWidgetTrackingActions.ResetSelectedOption,
      payload: { contentItem, questionWidget },
    });
    await persistTrackingChange(getState, trackingClient);
  };
